import { ReactComponent as FlagIcon } from "./svg/ar-flag.svg";
import "../flag-icon.scss";

export const ARFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
